<script lang="ts" setup>
import Icon from '@ui/components/icon.vue';

const emit = defineEmits(['show']);
</script>
<template>
    <button
        class="hover:text-brand-400 m-0 flex h-10 w-10 cursor-pointer items-center justify-center rounded-full bg-transparent p-0 text-gray-400 hover:bg-gray-900 focus:outline-none"
        @click="emit('show')"
    >
        <Icon
            icon="far fa-search"
            class="text-current"
        ></Icon>
    </button>
</template>
